<div class="service-order-form">
    <app-autocomplete-search label="Tail Number"
                             [required]="true"
                             [optionValue]="['tailNumber']"
                             [options]="customerAircraftsDataSource"
                             [displayFn]="displayTailNumber"
                             [filter]="filters.tailNumberFilter"
                             (filterChanged)="onCustomerAircraftFilterChanged($event)"
                             (selectionChanged)="onCustomerAircraftChanged($event)"></app-autocomplete-search>

    <app-autocomplete-search *ngIf="!data.customerAircraft || data.customerAircraft.oid == 0"
                             [required]="true"
                             label="Aircraft Make/Model"
                             [optionValue]="['make', 'model']"
                             [options]="aircraftTypes"
                             [displayFn]="displayAircraft"
                             (selectionChanged)="onAircraftTypeChanged($event)"></app-autocomplete-search>

    <app-autocomplete-search
                             label="Customer"
                             [required]="true"
                             [optionValue]="['company']"
                             [options]="customerInfoByGroupDataSource"
                             [displayFn]="displayCustomerName"
                             [filter]="data.customerInfoByGroup"
                             (filterChanged)="onCustomerFilterChanged($event)"
                             (selectionChanged)="onCustomerInfoByGroupChanged($event)"></app-autocomplete-search>

    <div class="row">
        <div class="col-12">
            <mat-form-field>
                <mat-select (selectionChange)="serviceOnChanged()"
                            [(ngModel)]="data.serviceOn"
                            placeholder="Service On">
                    <mat-option *ngFor="let appliedDate of appliedDateTypes"
                                [value]="appliedDate.value">
                        {{ appliedDate.text }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="row">
        <div class="col-12 col-md-6">
            <mat-form-field>
                <input (dateChange)="onArrivalDateTimeLocalChanged()"
                       [required]="(data.serviceOn == 0)"
                       (focus)="arrivalDateTimeLocal.open()"
                       [(ngModel)]="data.arrivalDateTimeLocal"
                       [ngxMatDatetimePicker]="arrivalDateTimeLocal"
                       matInput
                       name="arrivalDateTimeLocal"
                       placeholder="Arrival Date (Local)"/>
                <mat-datepicker-toggle [for]="arrivalDateTimeLocal"
                                       matSuffix></mat-datepicker-toggle>
                <ngx-mat-datetime-picker #arrivalDateTimeLocal
                                         disabled="false"></ngx-mat-datetime-picker>
            </mat-form-field>
        </div>
        <div class="col-12 col-md-6">
            <mat-form-field>
                <input (dateChange)="onDepartureDateTimeLocalChanged()"
                       [required]="(data.serviceOn == 1)"
                       (focus)="departureDateTimeLocal.open()"
                       [(ngModel)]="data.departureDateTimeLocal"
                       [ngxMatDatetimePicker]="departureDateTimeLocal"
                       matInput
                       name="departureDateTimeLocal"
                       placeholder="Departure Date (Local)"/>
                <mat-datepicker-toggle [for]="departureDateTimeLocal"
                                       matSuffix></mat-datepicker-toggle>
                <ngx-mat-datetime-picker #departureDateTimeLocal
                                         disabled="false"></ngx-mat-datetime-picker>
            </mat-form-field>
        </div>
    </div>
</div>

<div *ngIf="errorMessage != ''" class="error-message">
    <p>{{errorMessage}}</p>
</div>
<div *ngIf="warningMessage != ''" class="warning-message">
    <p>{{warningMessage}}</p>
</div>

<div class="dialog-actions">
    <button (click)="onSaveChanges()"
            class="mr-1"
            color="accent"
            [disabled]="(!data.arrivalDateTimeLocal && data.serviceOn == 0) || (!data.departureDateTimeLocal && data.serviceOn == 1) || !data.customerAircraft || data.customerAircraft.aircraftId == 0 || !data.customerInfoByGroup || data.customerInfoByGroup.oid == 0"
            mat-flat-button>
        Start Service Order
    </button>
    <button (click)="onCancelClick()" mat-stroked-button>Cancel</button>
</div>

<ngx-ui-loader [loaderId]="dialogLoader"
               bgsPosition="center-center"
               fgsColor="#252d47"
               fgsType="fading-circle"
               overlayColor="rgba(0, 0, 0, 0.06)"
               pbColor="#252d47"></ngx-ui-loader>
